import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PageHeader } from 'src/app/utils/models/page-header';
import { ForgotPwd } from '../../models/forgotpwd';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { ForgotpwdService } from '../../services/forgotpwd.service';
import { APIResponse } from 'src/app/utils/models/response';


@Component({
  selector: 'app-forgotpwd',
  templateUrl: './forgotpwd.component.html',
  styleUrls: ['./forgotpwd.component.css']
})
export class ForgotpwdComponent implements OnInit {
  entity: ForgotPwd = new ForgotPwd();
  entities: Array<ForgotPwd>;
  headerEntity: PageHeader;
  emailcheck: boolean = true;
  disableSave: boolean = true;
  disableOtp: boolean = true;
  dispassword: boolean = true;
  valid = 0;
  @Output() closeForgotPassword = new EventEmitter<null>();

  constructor(
    private _coreSaveService: CoreSaveService,
    private _notification: NotificationsService,
    private _forgotpwdService: ForgotpwdService,
  ) {
    this.headerEntity = this.initPageHeader();
    this.entities = [];

  }

  ngOnInit(): void {
  }
  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.PageCaption = "Forgot Password";
    headerEntity.IconClass = "bi bi-emoji-frown";
    return headerEntity;
  }
  checkValidPassword(): boolean {
    this.valid = 0;
    var special =/[!"£$%^&*()-_=+]/;
     var letter = /[a-z]/;
    var letterUp = /[A-Z]/;
    var number = /[0-9]/;

    const password = this.entity.password;
    if (password.length < 6 || !letter.test(password) || !letterUp.test(password) || !number.test(password) || !special.test(password)) {
      if (password.length < 6) {
        this._notification.showWarning("Please make sure password is longer than 6 characters.");
        this.valid++;
        return false;
      }
      else if (!letter.test(password) || !letterUp.test(password)) {
        this._notification.showWarning("Please make sure Password Includes an UpperCase and LowerCase character");
        this.valid++;
        return false;
      }
      else if(!special.test(password)){
        this._notification.showWarning("Please make sure that password includes special character");
        return false;
      }
      else if (!number.test(password)) {
        this._notification.showWarning("Please make sure Password Includes a Digit");
        this.valid++;
        return false;
      }
    }
    else {
      this.disableSave = false;

    }

    return true;
  }

  nameChanged() {
    if (this.entity.UserName != undefined) {
      this._forgotpwdService.viewDetails(this.entity.UserName).subscribe((response: Array<ForgotPwd>) => {
        if (response.length > 0) {
          this.entity.UserId = response[0].UserId;
          this.entity.Email = response[0].Email;
          this.entity.PhoneNumber = response[0].PhoneNumber;
        }
        else {
          this._notification.showWarning("Invalid User Name");
          return;
        }
      });
    }
  }
  otpChange() {
    if (this.entity.Otp != undefined && this.entity.UserId != undefined) {
      this._forgotpwdService.validateOtp(this.entity.Otp, this.entity.UserId).subscribe((response: Array<ForgotPwd>) => {
        if (response.length > 0) {

          this.dispassword = false;
          this.disableSave = true;
        }
        else {
          this._notification.showWarning("Invalid Otp entered");
          this.disableSave = true;
          return;
        }
      });
    }
  }
  generateOtp() {
    this._forgotpwdService.generateOtp(this.entity.UserId).subscribe((response: APIResponse) => {
      if (response.Success === true) {
        this._notification.showSuccess('OTP send to the registered email');
        this.disableOtp = false;
      }
      else {
        this.disableOtp = true;
      }
    })
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  save(event: any): void {
    this._forgotpwdService.savePassword(this.entity.UserName, this.entity.password).subscribe((response: APIResponse) => {
      if (response.Success === true) {
        this._notification.showSuccess('Password Changed Successfully');
        this.closeForgotPassword.emit();
        this.clear();
      }
    });
  }

  clear() {
    this.entity = new ForgotPwd();
  }
}



